<script setup lang="ts"></script>
<template>
  <v-card-title class="text-h4 mt-6">Binary logic</v-card-title>
  <v-card-text class="text-body-1 mt-3">
    <p class="mt-2">Second character from serial number</p>
    <v-img class="ma-4" height="200px" src="images/binary-logic-easy-doc.svg" />
  </v-card-text>
</template>
